export default __webpack_public_path__ + "images/usdt_dd4c74.svg";